import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Typography,
  Zoom
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  addLogistics,
  getLogistics,
  updateLogistics
} from '../../../redux/reducer/truckManagementSlices/logisticSlice';
import GoogleMap from '../../../../../common/components/maps/googlemap/GoogleMap';
import GoogleCircle from '../../../../../common/components/maps/googlecircle/GoogleCircle';
import GoogleMarkers from '../../../../../common/components/maps/googlemarkers/GoogleMarkers';
import GooglePolygon from '../../../../../common/components/maps/googlepolygon/GooglePolygon';
import GoogleSearchBox from '../../../../../common/components/maps/googlesearchbox/GoogleSearchBox';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { findAddress } from '../../../../../utils/commonFunctions';
import {
  map,
  updateCenter,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import './Logistics.scss';

const customerSchema: any = yup.object().shape({
  company: yup.string().trim().required('Enter the Company Name'),
  DbaName: yup.string().trim().notRequired(),
  firstName: yup
    .string()
    .typeError('First Name must be a string')
    .trim()
    .required('Enter the First Name')
    .matches(/^[A-Za-z]+$/, 'First Name must contain only alphabets')
    .min(3, 'First Name must be at least 3 characters'),
  lastName: yup
    .string()
    .typeError('Last Name must be a string')
    .trim()
    .required('Enter the Last Name')
    .matches(/^[A-Za-z]+$/, 'Last Name must contain only alphabets')
    .min(3, 'Last Name must be at least 3 characters'),
  mobile: yup
    .string()
    .typeError('Mobile Number must be a string')
    .required('Enter the Mobile Number')
    .trim()
    .matches(/^[0-9]{10}$/, 'Mobile Number must be exactly 10 digits')
    .min(10, 'Mobile Number must be exactly 10 digits')
    .max(10, 'Mobile Number must be exactly 10 digits'),
  email: yup
    .string()
    .typeError('Email must be a string')
    .trim()
    .required('Enter the Email')
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Enter valid email')
    .email('Enter the valid email'),
  address: yup.object().shape({
    source: yup.string().required('Enter address location'),
    startLat: yup.number().required('Enter address location'),
    startLng: yup.number().required('Enter address location')
  })
});

interface AddLogistics {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
  label: string;
  isLoading?: any;
  newValue?: any;
  setPageSize?: any;
  setPageNo?: any;
}

interface TextField {
  id: string;
  label: string;
  field:
    | 'company'
    | 'firstName'
    | 'lastName'
    | 'mobile'
    | 'email'
    | 'address'
    | 'DbaName';

  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
}

const AddLogistics = ({
  open,
  setOpen,
  roleType,
  filteredRow,
  label,
  isLoading,
  newValue,
  setPageSize,
  setPageNo
}: AddLogistics) => {
  const [address, setAddress] = useState<any>(null);
  const { isShow, fences } = useAppSelector(state => state.circle);
  const { isLoading: updateLoading, type } = useAppSelector(state => state.Logistics);
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    resetField,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(customerSchema)
  });

  const textField: TextField[] = [
    {
      id: '1',
      label: 'Company Name',
      field: 'company',
      placeholder: 'Company Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '2',
      label: 'DBA Name',
      field: 'DbaName',
      placeholder: 'DBA Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '3',
      label: 'First Name',
      field: 'firstName',
      placeholder: 'First Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '4',
      label: 'Last Name',
      field: 'lastName',
      placeholder: 'Last Name',
      inputProps: { maxLength: 40 }
    },
    {
      id: '5',
      label: 'Contact Number ',
      field: 'mobile',
      placeholder: 'Contact Number',
      inputProps: { maxLength: 10 }
    },
    {
      id: '6',
      label: 'Email',
      field: 'email',
      placeholder: 'Contact Email',
      inputProps: { maxLength: 40 }
    }
  ];

  const onSubmit = async (data: any) => {
    if (filteredRow) {
      let updatePayload: any = {
        address: data.address.source,
        company: data.company,
        dba_Name: data.DbaName,
        contactNumber: data.mobile,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        latitude: data.address.startLat,
        longitude: data.address.startLng,
        roleType: roleType
      };

      let payload: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      const action1 = await dispatch(updateLogistics(payload));
      if (action1.type === updateLogistics.fulfilled.type) {
        await dispatch(getLogistics({ roleType: newValue }));
        setPageNo(1);
        setPageSize(5);
        setOpen(false);
      }
    } else {
      const action2 = await dispatch(
        addLogistics({
          address: data.address.source,
          company: data.company,
          dba_Name: data.DbaName,
          contactNumber: data.mobile,
          email: data.email,
          firstName: data.firstName,
          lastName: data.lastName,
          latitude: data.address.startLat,
          longitude: data.address.startLng,
          roleType: roleType
        })
      );
      if (action2.type === addLogistics.fulfilled.type) {
        await dispatch(getLogistics({ roleType: newValue }));
        setPageNo(1);
        setPageSize(5);
        setOpen(false);
      }
    }
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const onClose = () => {
    setOpen(false);
    setAddress(null);
  };

  const handleMapClick = async (e: any) => {
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();
    dispatch(map([{ id: 1, lat, lng, name: 'location' }]));
    const fAdd = await findAddress(lat, lng);
    setAddress({
      geometry: {
        location: {
          lat: lat,
          lng: lng
        }
      },
      formatted_address: fAdd
    });
    // setValue('address', fAdd);
    setValue('address', {
      source: fAdd,
      startLat: lat,
      startLng: lng
    });
  };

  useEffect(() => {
    if (filteredRow) {
      setValue('firstName', filteredRow?.firstName);
      setValue('lastName', filteredRow?.lastName);
      setValue('mobile', filteredRow?.contactNumber);
      setValue('email', filteredRow?.email);
      setValue('company', filteredRow?.company);
      setValue('address', {
        source: filteredRow?.address,
        startLat: filteredRow?.latitude,
        startLng: filteredRow?.longitude
      });
      setAddress({
        geometry: {
          location: {
            lat: filteredRow?.latitude,
            lng: filteredRow?.longitude
          }
        },
        formatted_address: filteredRow?.address
      });
      clearErrors('address');
    }
  }, [filteredRow]);

  useEffect(() => {
    if (address && address?.geometry?.location?.lat) {
      let lat = address?.geometry?.location?.lat;
      let lng = address?.geometry?.location?.lng;
      setValue('address', {
        source: address?.formatted_address,
        startLat: lat,
        startLng: lng
      });
      clearErrors('address');
      dispatch(map([{ id: 1, lat: lat, lng: lng, name: 'location' }]));
      dispatch(updateZoom([{ id: 1, lat: lat, lng: lng, name: 'location' }]));
      dispatch(updateCenter([{ id: 1, lat: lat, lng: lng, name: 'location' }]));
    } else {
      setValue('address', {});
    }

    return () => {
      dispatch(map([]));
    };
  }, [address]);

  return (
    <>
      <Dialog
        open={open}
        className='dialog animate__animated animate__zoomInRight'
        sx={{ zIndex: 1, position: 'absolute' }}
        slotProps={{
          backdrop: {
            invisible: true
          }
        }}
      >
        <DialogContent>
          <Grid
            container
            sx={{
              flexDirection: { xs: 'column-reverse', md: 'row', sm: 'row' },
              gap: { lg: 1, md: 1, sm: 1 },
              padding: '0px 40px'
            }}
          >
            <Grid item xs={12} md={8} sm={8} lg={9}>
              <Box
                sx={{
                  width: '100%',
                  height: '83vh',
                  overflow: 'hidden',
                  position: 'sticky',
                  top: '0px'
                }}
              >
                <GoogleMap handleMapClick={handleMapClick} maplegend={false}>
                  {isShow && <GoogleCircle />}
                  <GoogleMarkers />
                  <GooglePolygon />
                </GoogleMap>
              </Box>
            </Grid>
            <Divider orientation='vertical' variant='middle' flexItem />
            <Grid item xs={12} md={3.6} sm={3.6} lg={2.8}>
              <Box
                className='logistic-scroll'
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px'
                }}
              >
                <Box className='closeIcon icon-position d-flex' onClick={onClose}>
                  <CustomIconButton category='CloseValue' />
                </Box>

                <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Box
                    className='animate__animated animate__zoomIn animate__slow'
                    component={'form'}
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    {textField?.map(item => (
                      <CustomTextField
                        key={item.id}
                        control={control}
                        name={item.field}
                        placeholder={item.placeholder}
                        id={item.id}
                        isOptional={item.field === 'DbaName' ? true : false}
                        type={item?.field === 'address' ? 'address' : null}
                        label={item.label}
                        inputProps={item.inputProps}
                      />
                    ))}
                    <GoogleSearchBox
                      id='address'
                      name='address'
                      control={control}
                      label='Address'
                      placeholder='Search location'
                      value={address?.formatted_address}
                      onchange={(e: any) => {
                        if (!e.target.value) {
                          resetField('address');
                          setAddress(null);
                        }
                      }}
                      setAddress={(address: any) => {
                        setAddress({
                          geometry: {
                            location: {
                              lat: address?.geometry?.location?.lat(),
                              lng: address?.geometry?.location?.lng()
                            }
                          },
                          formatted_address: address?.formatted_address
                        });
                      }}
                    />

                    <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                      <CustomButton
                        className='saveChanges'
                        type='submit'
                        category={label}
                        loading={(type === 'add' || type === 'update') && updateLoading}
                      />
                      <CustomButton
                        className='cancel'
                        category='Cancel'
                        onClick={() => {
                          handleClose();
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddLogistics;
